import { Row, Col, DatePicker, message } from "antd";
import React, { useState, useRef, useEffect } from "react";
import { Input, Button } from "antd";
import { CustomLabel } from "../../../Common/style";
import { BannerWrapper } from "../../../Components/UI/BannerWrapper";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import OtpCard from "../../../Components/OTPCard";
import { resetAppointmentDetails } from "../../../Redux/AppointmentDetails/action";
import "./style.css";
import {
  CenterDiv,
  DatePickerCom,
  error_message,
  getURlParameter,
  InputWrapper,
  numeric_validation_regx,
  SearchButton,
} from "../../../Constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleRight,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { dateIcon } from "../../../Assets/Images";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { formatMomentDate } from "../../../Services/Utils/dateFormat";
import {
  ERROR_RESPONSE,
  RESET_RESPONSE_POLICY,
} from "../../../Redux/ErrorResponse/types";
import { dateIsValid } from "../../../Utils";
import { ErrorMessage } from "./data";
import { postApi } from "../../../Services/apiService";
import { getPolicyDetails } from "../../../Redux/PolicyNumber/action";
import { PolicyDetails } from "../CommonData";
import { GET_RENEWAL_POLICY, GET_OTP_DETAILS, VERIFY_OTP_DETAILS  } from "../../../Services/endpoints";
import { RESET_ACCEPT_OFFER_PDF_DETAILS, STATUS_OF_APPLICATION } from "../../../Redux/PolicyNumber/types";
import { useCaptcha } from "../../../Utils/recaptcha";
import { startLoader } from "../../../Utils/index";
import { decrypt, encrypt } from "../../../Services/AESEncryptionDecryption";

const LandingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { errorMessage, error } = ErrorMessage();
  const { handleReCaptchaVerify, captchaToken} = useCaptcha();
  const [enteredOTP, setEnteredOTP] = useState("");
  const [otpId, setOtpId] = useState("");
  const { proposalDetails, policyNum} = PolicyDetails();
  const [inputValObj, setInputVal] = useState({
    inputVal: "",
    inputError: false,
  });
  const { inputVal, inputError } = inputValObj;
  const [dateValueObj, setValue] = useState({
    dateValue: undefined,
    dateError: false,
  });
  const { dateValue, dateError } = dateValueObj;
  const datePickerRef = useRef(null);
  const ref = useRef(null);

  const handleChange = (e) => {
    setValue({ ...dateValueObj, ...{ dateValue: formatMomentDate(e) } });
  };

  const byPassApiCall = async () => {
    let policynum = null;
    let applicationNum = null;

    const dob = getURlParameter("dob") || "";
    let testData = getURlParameter("pno").replaceAll("/", "");

    if (numeric_validation_regx.test(testData)) {
      applicationNum = getURlParameter("pno");
    } else {
      policynum = getURlParameter("pno");
    }

    // dispatch(getPolicyDetails(data));
    // return navigate("/status");
    dispatch({
      type: STATUS_OF_APPLICATION,
      payload: {
        localPolicyNumber: policynum,
        localApplicationNumber: applicationNum,
      },
    });
    try {
      const payload = {
        policyNum: policynum,
        birthDt: dob,
        applicationID: applicationNum,
        token: captchaToken
      }
      const encryptedPayload = encrypt(JSON?.stringify(payload));
      const result = await postApi(GET_RENEWAL_POLICY, {
        encodedString: encryptedPayload
      });
      const decryptedResponse = JSON?.parse(decrypt(result?.data?.response));
      if (!decryptedResponse?.policyStatus) {
        return dispatch({
          type: ERROR_RESPONSE,
          payload: { errorMessage: result?.data?.errorMessage },
        });
      }
      dispatch(getPolicyDetails(decryptedResponse));
      navigate("/status");
    } catch (error) {
      console.error(error)
     }
  };

  const onSearch = async () => {
    if (!dateIsValid(formatMomentDate(dateValue))) {
      setValue({ ...dateValueObj, ...{ dateError: true } });
      dispatch({
        type: ERROR_RESPONSE,
        payload: { errorMessage: error_message.date_input_error },
      });
      return;
    } else {
      setValue({ ...dateValueObj, ...{ dateError: false } });
      dispatch({ type: RESET_RESPONSE_POLICY });
    }

    let policynum = null;
    let applicationNum = null;

    let testData = inputVal.replaceAll("/", "");

    if (numeric_validation_regx.test(testData)) {
      applicationNum = inputVal;
    } else {
      policynum = inputVal;
    }
    // {"MOCK DATA"}
    // dispatch(getPolicyDetails(data));
    // return navigate("/status");

    dispatch({
      type: STATUS_OF_APPLICATION,
      payload: {
        localPolicyNumber: policynum,
        localApplicationNumber: applicationNum,
      },
    });
    handleCallGetPolicyOnSearch(policynum, applicationNum)
  };

  const handleCallGetPolicyOnSearch = async (policynum, applicationNum) => {
    const newToken = await handleReCaptchaVerify();
    try {
      const payload = {
        policyNum: policynum,
        birthDt: dateValue,
        applicationID: applicationNum,
        token: newToken
      }
      const encryptedPayload = encrypt(JSON?.stringify(payload));
      const result = await postApi(GET_RENEWAL_POLICY, {
        encodedString: encryptedPayload
      });
      const decryptedResponse = JSON?.parse(decrypt(result?.data?.response));
      if (!decryptedResponse?.policyStatus) {
        return dispatch({
          type: ERROR_RESPONSE,
          payload: { errorMessage: result?.data?.errorMessage },
        });
      }
      //DISPATCH POLICY DETAILS
      dispatch(getPolicyDetails(decryptedResponse));
      //SEND OTP
      if(decryptedResponse?.proposalDetails?.ProposerMobile && decryptedResponse?.policyNum){
        sendOtp(decryptedResponse?.proposalDetails?.ProposerMobile, decryptedResponse?.proposalDetails?.ProposerEmail, decryptedResponse?.policyNum)
      }
      else {
        navigate("/status")
      }
    } catch (error) {
      console.error(error)
    }
  }
  const sendOtp = async (proposerMobile, proposerEmail, policyNum) => {
    try {
      const payload = {
        phoneNumber : proposerMobile,
        applicationNumber: policyNum,
        emailId: proposerEmail
      };
      const encryptedPayload = encrypt(JSON?.stringify(payload));
      const result = await postApi(GET_OTP_DETAILS, {
        encodedString: encryptedPayload
      });
      if (result?.data?.response?.otpId) {
        setOtpId(result?.data?.response?.otpId)
        return result?.data?.response?.otpId;
      }
    } catch (error) {
      message.error(error?.errorMessage)
      console.error(error)
    }
  }

  const resendOTP = () => {
    return sendOtp(proposalDetails?.ProposerMobile, proposalDetails?.ProposerEmail, policyNum)
  }

  const verifyOtp = async () => {
    try {
      const result = await postApi(VERIFY_OTP_DETAILS, {
        enteredOtp: enteredOTP,
        otpId
      });
      if (result?.data?.enteredOTPValid) {
        navigate("/status");
      }
      else {
        message.error(result?.data?.otpValidationFailedMessage);
      }
    } catch (error) {
      message.error(error_message?.common_error)
      console.error(error)
    }
  }

  useEffect(() => {
    localStorage.clear();
    dispatch(resetAppointmentDetails());
    dispatch({ type: RESET_RESPONSE_POLICY });
    dispatch({ type: RESET_ACCEPT_OFFER_PDF_DETAILS });
    if (getURlParameter("pno") && getURlParameter("dob")) {
      startLoader()
    }
  }, []);

  useEffect(()=>{
    if(captchaToken && getURlParameter("pno") && getURlParameter("dob")){
      byPassApiCall();
    }
  },[captchaToken])

  return (
    <React.Fragment>
      <BannerWrapper className={"center_item"}>
        <Row>
          <Col lg={24} md={24} xs={24} style={{ textAlign: "center" }}>
            <CustomLabel font_size="44" color="white">
              Welcome Back!
            </CustomLabel>
          </Col>
          <Col lg={24} md={24} xs={24} style={{ textAlign: "center" }}>
            <CustomLabel font_weight="normal" color="white">
              {"You can track your application/renewal status"}
            </CustomLabel>
          </Col>
        </Row>
      </BannerWrapper>
      <div className="application-section">
        <Row justify="center">
          <Col lg={18} md={18} xs={22}>
            <SectionCardWrapper>
              <div>
                <Row>
                  <Col lg={12} md={24}>
                    <Row>
                      <Col lg={24} md={24} xs={24}>
                        <CustomLabel font_weight="bold" font_size="16">
                          {" "}
                          Enter Application/Policy No.{" "}
                          <span style={{ color: "red" }}>*</span>
                        </CustomLabel>
                      </Col>
                      <Col lg={24} md={24} xs={24}>
                        <InputWrapper error={false}>
                          <Input
                            placeholder="Enter Application/Policy No."
                            ref={ref}
                            value={inputVal}
                            maxLength={15}
                            onChange={(e) => {
                              let val = e.target.value.replace(
                                /[^a-zA-Z0-9]/gi,
                                ""
                              );
                              val = val.trim();
                              setInputVal({ ...inputValObj, inputVal: val });
                            }}
                            type="text"
                          />
                        </InputWrapper>
                        {/* <p style={{ fontSize: "11px", fontWeight: "normal" }}>
                          For example: PROHLV750000000 or 111111111111/00/00
                        </p> */}
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={12} md={24}>
                    <Row>
                      <Col lg={24} md={24} xs={24}>
                        <CustomLabel font_weight="bold" font_size="16">
                          {" "}
                          Date of Birth <span style={{ color: "red" }}>*</span>
                        </CustomLabel>
                      </Col>
                      <Col lg={24} md={24} xs={24}>
                        <Row justify="space-between">
                          <Col lg={10} md={12} xs={24}>
                            <div
                              style={{
                                display: "flex",
                                justify: "space-between",
                              }}
                            >
                              <DatePickerCom error={false}>
                                <DatePicker
                                  allowClear={true}
                                  ref={datePickerRef}
                                  // placement={
                                  //   scrollPos ? "bottomRight" : "topRight"
                                  // }
                                  onChange={handleChange}
                                  disabledDate={(e) =>
                                    e && e.valueOf() > Date.now()
                                  }
                                  showToday={false}
                                  format="DD/MM/YYYY"
                                />
                              </DatePickerCom>
                              <CenterDiv>
                                <div className="calender_icon ">
                                  <img src={dateIcon} />
                                </div>
                              </CenterDiv>
                            </div>
                            <p
                              style={{
                                fontSize: "11px",
                                fontWeight: "normal",
                                marginTop: "10px",
                              }}
                            >
                              For example: DD/MM/YYYY
                            </p>
                          </Col>
                          <Col lg={10} md={12} xs={24}>
                            <SearchButton>
                              <CenterDiv style={{ height: "100%" }}>
                                <Button
                                  onClick={() => onSearch()}
                                  type="text"
                                  disabled={Boolean(otpId)}
                                >
                                  Track Now{" "}
                                  <FontAwesomeIcon
                                    icon={faAngleRight}
                                    style={{ marginLeft: "15px" }}
                                  />
                                </Button>
                              </CenterDiv>
                            </SearchButton>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24} style={{ textAlign: "center" }}>
                    {errorMessage && (
                      <Row>
                        <Col lg={24}>
                          <div className="error_message">
                            <Row
                              justify="space-around"
                              align="middle"
                              gutter={8}
                            >
                              <Col span={4}>
                                <div className="warning">
                                  <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    color={"#ef969b"}
                                  />
                                </div>
                              </Col>
                              <Col span={20}>
                                <div
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  }}
                                >
                                  {errorMessage}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    )}
                    {otpId && (
                      <Col
                        lg={24}
                        md={24}
                        xs={24}
                        span={24}
                        style={{
                          marginBottom: "20px",
                          marginTop: "20px",
                          textAlign: "center",
                        }}
                      >
                        <Row justify="center">
                          <Col lg={12} xs={24}>
                            <div>
                              <OtpCard
                                resendOtp={resendOTP}
                                validateOtp={verifyOtp}
                                otpValue={enteredOTP}
                                setOtpValue={setEnteredOTP}
                                btnAlign="left"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Col>
                </Row>
              </div>
            </SectionCardWrapper>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default LandingPage;
